var exports = {
  "p_": "xa15a2ab7--8b0f56--list",
  "AS": "xa15a2ab7--8b0f56--item",
  "VN": "xa15a2ab7--8b0f56--close",
};

module.exports = exports;
